import React from "react";
import { Box, Typography, Link, Chip } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { MatxLayoutSettings } from "app/components/MatxLayout/settings";
import { DateFormatterByDateMonthYear } from "app/views/commons/commons";
import { FUNDRAISING_LABEL, TICKETING_LABEL, ticketingEvent } from "app/utils/constant";

const DashboardHeader = ({ eventData, onBack }) => {
  return (
    <Box sx={{ mb: 4 }}>
      <Box display="flex" alignItems="center" gap={1} mb={0.5}>
        <Link
          component="button"
          onClick={onBack}
          underline="hover"
          sx={{
            color: MatxLayoutSettings.palette.active,
            display: "flex",
            alignItems: "center",
            fontSize: "0.85rem",
            fontWeight: "500",
          }}
        >
          <ArrowBackIcon sx={{ fontSize: "1rem", mr: 0.5 }} /> {eventData?.name}
        </Link>
        <Typography color={MatxLayoutSettings.palette.textBlack} sx={{ fontSize: "0.85rem" }}>
          / Dashboard
        </Typography>
      </Box>

      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="flex-start"
        sx={{ flexDirection: { xs: "column", sm: "row" }, gap: { xs: 2, sm: 0 } }}
      >
        <Box>
          <Typography
            variant="h4"
            fontWeight="800"
            sx={{
              color: MatxLayoutSettings.palette.black,
              mb: 1,
              fontSize: { xs: "1.75rem", sm: "2.125rem" },
            }}
          >
            {eventData?.name}
          </Typography>
          <Box display="flex" alignItems="center" gap={1.5} mb={1.5} sx={{ flexWrap: "wrap" }}>
            <Chip
              label={eventData?.category !== ticketingEvent ? FUNDRAISING_LABEL : TICKETING_LABEL}
              size="small"
              sx={{
                bgcolor: MatxLayoutSettings.palette.purple,
                color: MatxLayoutSettings.palette.active,
                fontWeight: 600,
                borderRadius: "16px",
                height: "28px",
                "& .MuiChip-label": {
                  px: 1.5,
                  fontSize: "13px",
                  fontWeight: 600,
                },
              }}
            />
            <Chip
              label={eventData?.status || "Active"}
              size="small"
              icon={<CheckCircleIcon sx={{ color: "inherit !important", fontSize: "18px !important" }} />}
              sx={{
                bgcolor: MatxLayoutSettings.palette.dimGreen,
                color: MatxLayoutSettings.palette.limeGreen,
                fontWeight: 600,
                borderRadius: "16px",
                height: "28px",
                "& .MuiChip-label": {
                  pl: 0.5,
                  pr: 1.5,
                  fontSize: "13px",
                  fontWeight: 600,
                },
                "& .MuiChip-icon": {
                  ml: "8px",
                },
              }}
            />
          </Box>
          <Box
            display="flex"
            alignItems="center"
            color={MatxLayoutSettings.palette.textBlack}
            gap={2}
            sx={{ flexWrap: "wrap" }}
          >
            {(eventData?.start_date || eventData?.end_date) && (
              <Box display="flex" alignItems="center" gap={0.5}>
                <CalendarTodayIcon sx={{ fontSize: "1rem", color: MatxLayoutSettings.palette.textBlack }} />
                <Typography variant="body2" fontWeight="500">
                  {DateFormatterByDateMonthYear(eventData?.start_date) ===
                    DateFormatterByDateMonthYear(eventData?.end_date)
                    ? DateFormatterByDateMonthYear(eventData?.start_date)
                    : DateFormatterByDateMonthYear(eventData?.start_date) +
                    " - " +
                    DateFormatterByDateMonthYear(eventData?.end_date)}
                </Typography>
              </Box>
            )}

            {eventData?.venue && (
              <Box display="flex" alignItems="center" gap={0.5}>
                <LocationOnIcon sx={{ fontSize: "1rem", color: MatxLayoutSettings.palette.textBlack }} />
                <Typography variant="body2" fontWeight="500">
                  {eventData?.venue}
                </Typography>
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default DashboardHeader;
